(function() {
    function initFooterAccordions() {
      var triggers = document.querySelectorAll('.footer-accordion-trigger[data-accordion-trigger]');
      triggers.forEach(function(trigger) {
        var content = trigger.nextElementSibling;
        if (!content) return;

        trigger.addEventListener('click', function() {
          // Only run on mobile
          if (window.innerWidth >= 980) return;

          var isOpen = trigger.classList.contains('is-open');

          // Close all
          triggers.forEach(function(t) {
            t.classList.remove('is-open');
            var c = t.nextElementSibling;
            if (c) c.classList.remove('is-open');
          });

          // Open clicked if it was closed
          if (!isOpen) {
            trigger.classList.add('is-open');
            content.classList.add('is-open');
          }
        });
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initFooterAccordions);
    } else {
      initFooterAccordions();
    }
  })();


  